<template>
  <div class="settingsArea">
    <div class="settingsArea__backToSettings" v-if="isShrinkedWidth && currentTab">
      <div class="settingsArea__backToSettings__button" @click="goBackToSettings">Back to settings</div>
      <SettingsCloseButton />
    </div>
    <div class="settingsArea__separator" v-if="isShrinkedWidth"></div>
    <div class="settingsArea__header">
      <div class="settingsArea__title">{{ currentTab.title }}</div>
      <div class="settingsArea__description">{{ currentTab.description }}</div>
    </div>
    <component :is="currentTab.component"></component>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SettingsStore } from "../ELYXStore";
import SettingsMethods from "./SettingsMethods";

export default {
  components: {
    SettingsAreaProfile: () => import(/* webpackPrefetch: true */ "./SettingsAreaProfile.vue"),
    SettingsAreaPassword: () => import(/* webpackPrefetch: true */ "./SettingsAreaPassword.vue"),
    SettingsAreaEmail: () => import(/* webpackPrefetch: true */ "./SettingsAreaEmail.vue"),
    SettingsAreaPrivacy: () => import(/* webpackPrefetch: true */ "./SettingsAreaPrivacy.vue"),
    SettingsAreaIntegrations: () => import(/* webpackPrefetch: true */ "./SettingsAreaIntegrations.vue"),
    SettingsAreaBilling: () => import(/* webpackPrefetch: true */ "./SettingsAreaBilling.vue"),
    SettingsAreaDanger: () => import(/* webpackPrefetch: true */ "./SettingsAreaDanger.vue"),
    SettingsAreaNotifications: () => import(/* webpackPrefetch: true */ "./SettingsAreaNotifications.vue"),
    SettingsCloseButton: () => import("./SettingsCloseButton.vue"),
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      notifications: (state) => state.notifier.notifications,
    }),
    isShrinkedWidth() {
      if (this.$windowWidth < 750) {
        return true;
      }
      return false;
    },
    currentTab: () => SettingsStore.state.currentTab,
  },
  methods: {
    goBackToSettings() {
      SettingsMethods.goBackToSettings();
    },
  },
};
</script>

<style scoped>
.settingsArea {
  width: 690px;
  border-radius: 16px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px;
}
.settingsArea__header {
  margin-bottom: 15px;
}
.settingsArea__title {
  font-size: 22px;
  margin-bottom: 5px;
  margin-top: 5px;
  color: #333;
}
.settingsArea__description {
  color: #666;
  line-height: 26px;
}
.settingsArea__backToSettings {
  z-index: 1;
  background-color: #efefef;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 0px 15px;
  box-sizing: border-box;
  height: 60px;
  display: flex;
  align-items: center;
}
.settingsArea__backToSettings__button {
  border-radius: 360px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  padding: 10px 12px;
  font-size: 16px;
  cursor: pointer;
  box-sizing: border-box;
  margin-left: -8px;
  color: #333;
}
.settingsArea__separator {
  margin-bottom: 60px;
}
.settingsArea__backToSettings__button:hover {
  border-color: transparent;
  background-color: rgb(255 255 255 / 0.5);
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
}
@media (max-width: 940px) {
  .settingsArea {
    width: calc(100% - 251px);
  }
}
@media (max-width: 749px) {
  .settingsArea {
    width: 100%;
  }
}
</style>
